"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function ValueContainer(props) {
  // eslint-disable-next-line
  var selectProps = props.selectProps,
      children = props.children;
  return _react["default"].createElement("div", {
    className: selectProps.classes.valueContainer
  }, children);
}

var _default = ValueContainer;
exports["default"] = _default;